import IconButton from "@mui/material/IconButton";
import { TextField, Button, Grid, Typography } from "@mui/material";

import { LockOutlined } from "@mui/icons-material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import makeStyles from "@mui/styles/makeStyles";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { UserRegister } from "../_api/registerApi";
import Cookies from "universal-cookie";
import PropTypes from "prop-types";
import { TimeLoader } from "../_components/loaders/TimeLoader";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: { margin: theme.spacing(3, 0, 2) },
  buttonIco: { width: 24, height: 24, marginRight: 10, marginTop: 7 },
  inputIco: { opacity: 0.6, color: "#1c355e", paddingRight: "5px" },
}));

const Password = ({ handleNext, UpdateUserInfo, userInfo }) => {
  const cookies = new Cookies();
  const [showSpinner, setShowSpinner] = useState(false);
  const [disableInputs, setDisableInputs] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const showApiErrorToast = () => {
    toast.error(
      <div>
        <Typography variant="h6" style={{ textDecoration: "underline" }}>
          {t("registration.apiErrorTitle")}
        </Typography>
        <Typography variant="body2">{t("registration.apiError")}</Typography>
      </div>
    );
  };
  const { t } = useTranslation();
  const classes = useStyles();
  const { register, errors, watch, handleSubmit } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const RegisterUser = (registerUserInfo) => {
    let registrationInformation = {
      brandIdentifier: registerUserInfo.brandIdentifier,
      firstName: registerUserInfo.firstName,
      lastName: registerUserInfo.lastName,
      email: registerUserInfo.email,
      password: registerUserInfo.password,
      homePhone: registerUserInfo.phoneNumber,
      cellPhone:
        registerUserInfo.phoneType === "cell"
          ? registerUserInfo.phoneNumber
          : "",
      homeAddress1: registerUserInfo.homeAddress1,
      homeAddress2: registerUserInfo.homeAddress2,
      city: registerUserInfo.city,
      county: registerUserInfo.county,
      state: registerUserInfo.state,
      zip: registerUserInfo.zip,
      dob: registerUserInfo.dob,
    };
    UserRegister(registrationInformation)
      .then((response) => {
        cookies.set("lifesaferUser", JSON.stringify(response), {
          path: "/",
          sameSite: "strict",
        });
        handleNext();
      })
      .catch((error) => {
        console.error("Error registering user : ", error);
        showApiErrorToast();
        setDisableInputs(false);
        setShowSpinner(false);
      });
  };

  const submitPassword = (data) => {
    setDisableInputs(true);
    setShowSpinner(true);
    UpdateUserInfo(data);
    RegisterUser({ ...userInfo, ...data });
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(submitPassword)}>
      <TextField
        variant="outlined"
        margin="normal"
        autoComplete="new-password"
        size="small"
        fullWidth
        required
        type={showPassword ? "text" : "password"}
        label={t("registration.password")}
        name="password"
        id="password"
        disabled={disableInputs}
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : ""}
        autoFocus
        inputRef={register({
          required: {
            value: true,
            message: t("registration.passwordRequired"),
          },
          pattern: {
            value:
              /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,24}$/,
            message: t("registration.passwordPattern"),
          },
        })}
        InputProps={{
          "data-testid": "password",
          startAdornment: <LockOutlined className={classes.inputIco} />,
          endAdornment: (
            <IconButton onClick={toggleShowPassword} size="large">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          ),
        }}
      />
      <TextField
        variant="outlined"
        margin="normal"
        autoComplete="new-password"
        size="small"
        fullWidth
        required
        type={showPassword ? "text" : "password"}
        label={t("registration.confirmPassword")}
        name="confirmPassword"
        disabled={disableInputs}
        error={!!errors.confirmPassword}
        helperText={
          errors.confirmPassword ? errors.confirmPassword.message : ""
        }
        inputRef={register({
          required: {
            value: true,
            message: t("registration.confirmPasswordRequired"),
          },
          pattern: {
            value:
              /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,24}$/,
            message: t("registration.passwordPattern"),
          },
          validate: (value) => {
            if (value === watch("password")) {
              return true;
            } else {
              return t("registration.confirmPasswordMatch");
            }
          },
        })}
        InputProps={{
          startAdornment: <LockOutlined className={classes.inputIco} />,
          endAdornment: (
            <IconButton onClick={toggleShowPassword} size="large">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          ),
        }}
      />

      <Grid
        container
        direction="column"
        alignContent="center"
        alignItems="center"
      >
        {showSpinner ? (
          <Grid item style={{ padding: 15, margin: 15 }}>
            <TimeLoader />
          </Grid>
        ) : (
          <Grid item style={{ paddingTop: 10, marginTop: 10 }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ width: 240, height: 50 }}
            >
              {t("registration.createAccount")}
            </Button>
          </Grid>
        )}
      </Grid>
    </form>
  );
};

Password.propTypes = {
  userInfo: PropTypes.object,
  UpdateUserInfo: PropTypes.func,
  handleNext: PropTypes.func,
};

export default Password;
